import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'creditType',
    label: 'Credit Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'purchaseCreditType',
    label: 'Purchase Credit Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'description',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sourceType',
    label: 'Source Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherDescription',
    label: 'Other Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'amount',
    label: 'Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const creditsForm = {
  name: FormNames.CREDITS,
  label: 'Credits',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
